<template>
  <div class="ocorrencia-esfinge-page">
    <div class="az-form-content pa-3">
      <v-layout wrap align-center>
        <v-flex xs12 sm4 class="pr-sm-2">
          <v-select
            name="Licitação"
            key="Licitação"
            label="Licitação"
            placeholder="Selecione a Ocorrência da Licitação"
            :menu-props="{ top: false, offsetY: true }"
            v-model="dados.ocorrenciaLicitacao"
            class="required-field"
            v-validate="'required'"
            :items="Object.entries(tiposOcorrenciaLicitacao).map(([key, value]) => ({ key: value.valor, value: value.texto }))"
            :error-messages="errors.collect('Licitação')"
            item-text="value"
            item-value="key"
            clearable
          />
        </v-flex>
        <v-flex xs12 sm4 class="pr-sm-2">
          <v-select
            name="Decisão"
            key="Decisão"
            label="Decisão"
            placeholder="Selecione a Decisão da Licitação"
            :menu-props="{ top: false, offsetY: true }"
            v-model="dados.decisaoOcorrencia"
            class="required-field"
            v-validate="'required'"
            :items="Object.entries(tiposDecisaoOcorrencia).map(([key, value]) => ({ key: value.valor, value: value.texto }))"
            :error-messages="errors.collect('Decisão')"
            item-text="value"
            item-value="key"
            clearable
          />
        </v-flex>
      </v-layout>
      <v-layout wrap align-center>
        <v-flex xs12 sm12 v-if="!exibirItensLotesDesertosFracassados">
          <v-textarea
              v-model="dados.justificativaOcorrencia"
              class="required-field"
              v-validate="'required'"
              rows="2"
              name="Justificativa"
              key="Justificativa"
              label="Justificativa"
              placeholder="Insira a Justificativa"
              :error-messages="errors.collect('Justificativa')"
              :counter="5000"
              maxlength="5000"
          />
        </v-flex>
      </v-layout>

      <div class="mt-4" v-if="exibirItensLotesDesertosFracassados">
        <v-data-table
          :headers="headers"
          :items="itensFiltrados"
          item-key="uid"
          class="az-table-list"
        >
          <template slot="headers" slot-scope="{ headers }">
            <tr>
              <th class="text-center col-checkbox">
                <input type="checkbox" :checked="selecionarTodos" @change="toggleSelecionarTodos($event.target.checked)"/>
              </th>
              <th
                v-for="header in headers.slice(1)"
                :key="header.value"
                :class="[
                  { 'text-center': header.value !== 'descricao' },
                  `col-${header.value}`
                ]"
              >
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="{ item }">
            <td class="text-center col-checkbox">
              <input type="checkbox"
                     v-model="selecionadosMap[item.uid]"
                     @change="aoAlterarSelecao(item)"
              />
            </td>
            <td class="text-center col-tipoLabel">{{ item.tipoLabel }}</td>
            <td class="td-descricao col-descricao">
              <div>
                <strong>{{ item.codigo }}</strong>
                <span v-if="item.descricao">
                  -
                  <span v-if="deveTruncarDescricao(item) && !descricaoExpandida[item.uid]">
                    {{ descricaoTruncada(item) }}
                    <a href="#" @click.prevent="expandirDescricao(item.uid)">ver mais</a>
                  </span>
                  <span v-else>
                    {{ item.descricao }}
                    <template v-if="deveTruncarDescricao(item) && descricaoExpandida[item.uid]">
                      <a href="#" @click.prevent="reduzirDescricao(item.uid)">ver menos</a>
                    </template>
                  </span>
                </span>
              </div>
            </td>
            <td class="text-center col-situacao">{{ mapSituacao(item.situacao) }}</td>
            <td class="td-sem-padding text-center col-justificativa">
              <v-textarea
                v-model="justificativas[item.uid]"
                :placeholder="placeholderJustificativa(item)"
                @focus="definirDefaultSeVazio(item)"
                rows="1"
                :counter="5000"
                maxlength="5000"
              ></v-textarea>
            </td>
          </template>
          <template slot="no-data">
            Nenhum item encontrado.
          </template>
        </v-data-table>
      </div>

      <div class="az-actions-form mt-3">
        <v-btn outline color="primary" class="mt-4 mb-8" @click="voltarParaExecucao">Cancelar</v-btn>
        <v-spacer></v-spacer>
        <v-btn class="botao-primario" flat @click="enviar">Enviar</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { actionTypes, tiposDecisaoOcorrencia, tiposOcorrenciaLicitacao, situacoesItensELotes } from '@/core/constants'

export default {
    name: 'OcorrenciaEsfinge',
    data () {
        return {
            compraDiretaId: null,
            dados: {
                ocorrenciaLicitacao: '',
                decisaoOcorrencia: '',
                justificativaOcorrencia: ''
            },
            selecionados: [],
            selecionadosMap: {},
            justificativas: {},
            descricaoExpandida: {},
            selecionarTodos: false,
            headers: [
                { text: '', value: 'selecionar', sortable: false, width: 40 },
                { text: 'Tipo', value: 'tipoLabel' },
                { text: 'Código/Descrição', value: 'descricao' },
                { text: 'Situação', value: 'situacao' },
                { text: 'Justificativa', value: 'justificativa', sortable: false }
            ],
            tiposDecisaoOcorrencia,
            tiposOcorrenciaLicitacao,
            situacoesItensELotes
        }
    },
    computed: {
        ...mapState(['itensELotes', 'dadosGerais']),
        numeroProtocoloOcorrenciaEsfinge () {
            return this.dadosGerais && this.dadosGerais.numeroProtocoloOcorrenciaEsfinge
        },
        exibirItensLotesDesertosFracassados () {
            return this.dados.ocorrenciaLicitacao === 'DESERTO_FRACASSADO'
        },
        itensAplanados () {
            const uid = (tipo, id) => `${tipo}-${id}`
            const itens = (this.itensELotes && this.itensELotes.itens) ? this.itensELotes.itens.map(i => ({
                uid: uid('ITEM', i.id),
                tipo: 'ITEM',
                tipoLabel: 'Item ' + i.identificacaoSequencial,
                codigo: i.codigo,
                descricao: i.descricao,
                situacao: i.situacao,
                justificativaEsfingeOcorrencia: i.justificativaEsfingeOcorrencia,
                chaveIntegracaoEsfingeOcorrencia: i.chaveIntegracaoEsfingeOcorrencia
            })) : []
            const lotes = (this.itensELotes && this.itensELotes.lotes) ? this.itensELotes.lotes.map(l => ({
                uid: uid('LOTE', l.id),
                tipo: 'LOTE',
                tipoLabel: l.descricao,
                codigo: '--',
                descricao: null,
                situacao: l.situacao,
                justificativaEsfingeOcorrencia: l.justificativaEsfingeOcorrencia,
                chaveIntegracaoEsfingeOcorrencia: l.chaveIntegracaoEsfingeOcorrencia
            })) : []
            return [...itens, ...lotes]
        },
        itensFiltrados () {
            const tipo = this.dados.ocorrenciaLicitacao
            if (!tipo) return []
            return this.itensAplanados.filter(el => {
                if (el.situacao === 'FRACASSADO') return true
                if (el.situacao === 'DESERTO') return true
                return false
            })
        }
    },
    async mounted () {
        this.compraDiretaId = this.$route.params.id
        await this.$store.dispatch(actionTypes.BUSCAR_DADOS_GERAIS, this.compraDiretaId)
        await this.$store.dispatch(actionTypes.BUSCAR_ITENS_E_LOTES, this.compraDiretaId)
    },
    watch: {
        itensFiltrados (novo) {
            this.selecionarTodos = (novo && novo.length > 0) && novo.every(i => this.selecionadosMap[i.uid])
        },
        selecionadosMap: {
            handler () {
                const lista = this.itensFiltrados || []
                this.selecionarTodos = lista.length > 0 && lista.every(i => this.selecionadosMap[i.uid])
            },
            deep: true
        }
    },
    methods: {
        voltarParaExecucao () {
            if (window.history.length > 1) {
                this.$router.back()
            } else {
                this.$router.push({ name: 'ResultadoComprador', params: { id: this.compraDiretaId } })
            }
        },
        mapSituacao (s) {
            return this.situacoesItensELotes[s] || s
        },
        deveTruncarDescricao (item) {
            const d = item && item.descricao
            return !!(d && String(d).length > 150)
        },
        descricaoTruncada (item) {
            if (!item || !item.descricao) return ''
            const texto = String(item.descricao)
            return texto.substring(0, 150) + '...'
        },
        expandirDescricao (uid) {
            this.$set(this.descricaoExpandida, uid, true)
        },
        reduzirDescricao (uid) {
            this.$set(this.descricaoExpandida, uid, false)
        },
        placeholderJustificativa (item) {
            const texto = item && item.justificativaEsfingeOcorrencia && String(item.justificativaEsfingeOcorrencia).trim()
            if (texto) return texto
            if (item.situacao === 'DESERTO') return 'Não houve participante'
            if (item.situacao === 'FRACASSADO') return 'Licitantes Desclassificados/Inabilitados'
            return 'Informe a justificativa'
        },
        definirDefaultSeVazio (item) {
            const atual = this.justificativas[item.uid]
            if (!atual || !atual.trim()) {
                this.$set(this.justificativas, item.uid, this.placeholderJustificativa(item))
            }
        },
        atualizarSelecionados () {
            this.selecionados = this.itensAplanados.filter(i => this.selecionadosMap[i.uid])
        },
        limparSelecao () {
            const lista = this.itensAplanados || []
            for (const it of lista) {
                this.$set(this.selecionadosMap, it.uid, false)
            }
            this.selecionarTodos = false
            this.selecionados = []
        },
        aoAlterarSelecao (item) {
            this.atualizarSelecionados()
            if (this.selecionadosMap[item.uid]) {
                this.definirDefaultSeVazio(item)
            }
            this.selecionarTodos = this.itensFiltrados.length > 0 && this.itensFiltrados.every(i => this.selecionadosMap[i.uid])
        },
        toggleSelecionarTodos (checked) {
            const lista = this.itensFiltrados || []
            for (const it of lista) {
                this.$set(this.selecionadosMap, it.uid, !!checked)
                if (checked) this.definirDefaultSeVazio(it)
            }
            this.selecionarTodos = !!checked
            this.atualizarSelecionados()
        },
        async enviar () {
            const ehValido = await this.$validator.validate()
            if (!ehValido) return

            if (this.exibirItensLotesDesertosFracassados && (!this.selecionados || this.selecionados.length === 0)) {
                if (typeof this.mostrarNotificacaoErro === 'function') {
                    this.mostrarNotificacaoErro('Selecione ao menos um item ou lote para enviar.')
                }
                return
            }

            const montarItem = (s) => ({
                itemLoteCompraDiretaId: Number(s.uid.split('-')[1]),
                justificativaOcorrencia: (this.justificativas[s.uid] && this.justificativas[s.uid].trim())
                    ? this.justificativas[s.uid].trim()
                    : this.placeholderJustificativa(s),
                identificador: s.tipo,
                ocorrenciaLicitacao: s.situacao === 'FRACASSADO' ? 'ITEM_FRACASSADO' : 'ITEM_DESERTO'
            })

            const payloadBase = {
                compraDiretaId: this.compraDiretaId,
                ocorrenciaLicitacao: this.dados.ocorrenciaLicitacao,
                decisaoOcorrencia: this.dados.decisaoOcorrencia,
                justificativaOcorrencia: this.dados.justificativaOcorrencia
            }

            this.habilitarLoadingGlobal()
            this.setMensagemLoading('Enviando ocorrência...')

            try {
                if (!this.exibirItensLotesDesertosFracassados) {
                    if (this.numeroProtocoloOcorrenciaEsfinge) {
                        const info = await this.$store.dispatch(actionTypes.ESFINGE.BUSCAR_OCORRENCIA, this.numeroProtocoloOcorrenciaEsfinge)
                        const acao = (!info || info.permitirEnviar) ? actionTypes.ESFINGE.ENVIAR_OCORRENCIA : actionTypes.ESFINGE.ALTERAR_OCORRENCIA
                        const data = await this.$store.dispatch(acao, { ...payloadBase })
                        if (acao === actionTypes.ESFINGE.ENVIAR_OCORRENCIA && data && data.enviadoComSucesso) this.mostrarNotificacaoSucesso('Ocorrência enviada com sucesso.')
                        if (acao === actionTypes.ESFINGE.ALTERAR_OCORRENCIA && data && data.alteradoComSucesso) this.mostrarNotificacaoSucesso('Ocorrência alterada com sucesso.')
                    } else {
                        const data = await this.$store.dispatch(actionTypes.ESFINGE.ENVIAR_OCORRENCIA, { ...payloadBase })
                        if (data && data.enviadoComSucesso) this.mostrarNotificacaoSucesso('Ocorrência enviada com sucesso.')
                    }
                    await this.$store.dispatch(actionTypes.BUSCAR_ITENS_E_LOTES, this.compraDiretaId)
                    this.desabilitarLoadingGlobal()
                    return
                }

                const selecionadosComDados = this.selecionados.map(s => ({ ...s }))

                const getIdFromUid = (uid) => Number(uid && uid.split('-')[1])
                const getLoteByUid = (uid) => {
                    const id = getIdFromUid(uid)
                    const lotes = (this.itensELotes && this.itensELotes.lotes) || []
                    return lotes.find(l => l.id === id)
                }

                let enviarItens = []
                let alterarItens = []

                for (const sel of selecionadosComDados) {
                    if (sel.tipo === 'ITEM') {
                        if (!sel.chaveIntegracaoEsfingeOcorrencia) {
                            enviarItens.push(montarItem(sel))
                        } else {
                            const info = await this.$store.dispatch(actionTypes.ESFINGE.BUSCAR_OCORRENCIA, sel.chaveIntegracaoEsfingeOcorrencia)
                            if (!info || info.permitirEnviar) enviarItens.push(montarItem(sel))
                            else alterarItens.push(montarItem(sel))
                        }
                    } else if (sel.tipo === 'LOTE') {
                        const lote = getLoteByUid(sel.uid)
                        const itensDoLote = (lote && lote.itens) || []
                        let todosItensPermitemEnvio = true
                        for (const it of itensDoLote) {
                            if (it.chaveIntegracaoEsfingeOcorrencia) {
                                const infoItem = await this.$store.dispatch(actionTypes.ESFINGE.BUSCAR_OCORRENCIA, it.chaveIntegracaoEsfingeOcorrencia)
                                if (infoItem && !infoItem.permitirEnviar) {
                                    todosItensPermitemEnvio = false
                                    break
                                }
                            }
                        }
                        if (todosItensPermitemEnvio) enviarItens.push(montarItem(sel))
                        else alterarItens.push(montarItem(sel))
                    }
                }

                if (enviarItens.length > 0) {
                    const dataEnvio = await this.$store.dispatch(actionTypes.ESFINGE.ENVIAR_OCORRENCIA, { ...payloadBase, itemDesertoFracassadoList: enviarItens })
                    if (dataEnvio && dataEnvio.enviadoComSucesso) this.mostrarNotificacaoSucesso('Ocorrência enviada com sucesso.')
                    await this.$store.dispatch(actionTypes.BUSCAR_ITENS_E_LOTES, this.compraDiretaId)
                }

                if (alterarItens.length > 0) {
                    const dataAlteracao = await this.$store.dispatch(actionTypes.ESFINGE.ALTERAR_OCORRENCIA, { ...payloadBase, itemDesertoFracassadoList: alterarItens })
                    if (dataAlteracao && dataAlteracao.alteradoComSucesso) this.mostrarNotificacaoSucesso('Ocorrência alterada com sucesso.')
                    await this.$store.dispatch(actionTypes.BUSCAR_ITENS_E_LOTES, this.compraDiretaId)
                }

                this.limparSelecao()
                this.desabilitarLoadingGlobal()
            } catch (e) {
                this.desabilitarLoadingGlobal()
                this.mostrarNotificacaoErro(e.message)
            }
        }
    }
}
</script>

<style scoped>
.ocorrencia-esfinge-page .botao-primario {
  padding: 0 25px;
  border: 1px solid #1976d2 !important;
  background-color: #1976d2 !important;
  color: #fff !important;
  box-sizing: border-box;
  margin-left: 15px !important;
}

.checkbox-sem-borda .v-input--selection-controls__input {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

.td-sem-padding {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.td-sem-padding >>> .v-input {
  width: 100%;
}
.td-sem-padding >>> .v-input__slot {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.td-sem-padding >>> textarea {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.text-center {
  text-align: center !important;
}

.td-descricao {
  text-align: left !important;
}

/* Larguras máximas das colunas da tabela */
.az-table-list >>> table {
  table-layout: fixed;
  width: 100%;
}

.col-checkbox {
  max-width: 5%;
  width: 5%;
}

.col-tipoLabel {
  max-width: 5%;
  width: 5%;
}

.col-descricao {
  max-width: 40%;
  width: 40%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.col-situacao {
  max-width: 10%;
  width: 10%;
}

.col-justificativa {
  max-width: 20%;
  width: 20%;
}
</style>
